export const handleFetch = async (url, options) => {
	const header = {
		'Content-Type': 'application/json; charset=utf-8'
	};

	let fetchOptions = {
		headers: header,
		...options
	};

	try {
		const callResponse = await fetch(url, fetchOptions);
		let payload = null;
		const text = await callResponse.text();
		
		if (text) {
			try {
				payload = JSON.parse(text);
			} catch (err) {
				console.warn("Response is not valid JSON:", text);
				payload = text;
			}
		}

		return {
			data: payload,
			status: callResponse.status
		};

	} catch (e) {
		return {
			data: 'We are having some trouble on our end. Please try again later!',
			status: 500
		};
	}
};
